<script>
export default {
  name: "formInput",
  components: {},
  props: {
    //值
    value: {
      type: [String, Number],
      default: () => ""
    },
    //标题
    title: {
      type: String,
      default: ""
    },
    //标题宽度
    titleWidth: {
      type: String,
      default: ""
    },
    //提示
    placeholder: {
      type: String,
      default: "请输入"
    },
    //自动完成
    autocomplete: {
      type: Boolean,
      default: true
    },
    //必填
    required: {
      type: Boolean,
      default: false
    },
    //只读
    readonly: {
      type: Boolean,
      default: false
    },
    //禁用
    disabled: {
      type: Boolean,
      default: false
    },
    //是否启用清除图标
    clearable: {
      type: Boolean,
      default: false
    },
    //左侧图标名称或图片链接
    leftIcon: {
      type: String,
      default: ""
    },
    //右侧图标名称或图片链接
    rightIcon: {
      type: String,
      default: ""
    },
    //行数 适用于 type = textarea
    rows: {
      type: [String, Number],
      default: 2
    },
    //可以调节高度  适用于 type = textarea
    autosize: {
      type: Boolean,
      default: false
    },
    //类型 vant field
    type: {
      type: String,
      default: null
    },
    //focus时  选中所有输入值
    focusSelectAll: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      realValue: this.value
    };
  },
  watch: {
    realValue(e) {
      if (this.realValue != this.value) {
        this.$emit("input", e);
      }
    },
    value(e) {
      if (this.realValue != this.value) {
        this.realValue = e;
      }
    }
  },
  methods: {
    /**
     * @description: 获取值
     * @param {*}
     * @return {*}
     */
    getValue() {
      return this.realValue;
    },
    /**
     * @description: 赋值
     * @param {*}
     * @return {*}
     */
    setValue(e) {
      this.realValue = e;
    }
  },
  render() {
    let { readonly, disabled } = this;
    readonly = readonly || disabled;
    const option = {
      props: {
        readonly,
        disabled,
        type: this.type,
        label: this.title,
        value: this.realValue,
        labelWidth: this.titleWidth,
        required: this.required,
        clearable: this.clearable,
        leftIcon: this.leftIcon,
        rightIcon: this.rightIcon,
        rows: this.rows,
        autosize: this.autosize
      },
      attrs: {
        autocomplete: this.autocomplete
      },
      ref: "input"
    };
    if (!readonly) {
      option.props.placeholder = this.placeholder;
      let listeners = {};
      for (const key in this.$listeners) {
        listeners[key] = (...arg) => {
          this.$emit(key, ...arg);
        };
      }
      option.on = {
        ...listeners,
        focus: e => {
          if (this.focusSelectAll) {
            this.$refs.input.$refs.input.select();
          }
          this.$emit("submit", e);
        },
        input: e => {
          this.realValue = e;
          this.$emit("change", e);
        }
      };
    }
    if (this.$scopedSlots) {
      option.scopedSlots = this.$scopedSlots;
    }
    return (
      <div class="van-cell" style="padding:0">
        <van-field {...option} />
      </div>
    );
  }
};
</script>

<style lang="less" scoped></style>
